// Утилита для работы с конфигурацией фронтенда
export const getConfig = () => {
    // Проверяем, что конфигурация загружена
    if (typeof window !== 'undefined' && window.config) {
        return window.config;
    }
    
    // Fallback значения (для разработки)
    return {
        API_URL: 'https://oncaspin.com',
        ENVIRONMENT: 'development',
        VERSION: '1.0.0'
    };
};

// Получить API URL
export const getApiUrl = () => {
    const config = getConfig();
    return config.API_URL;
};

// Получить окружение
export const getEnvironment = () => {
    const config = getConfig();
    return config.ENVIRONMENT;
};

// Проверить, что это staging
export const isStaging = () => {
    return getEnvironment() === 'staging';
};

// Проверить, что это production
export const isProduction = () => {
    return getEnvironment() === 'production';
};

